<template>
  <el-container class="m-material material-index">
    <el-header class="container-header m-header material-head" style="height: 60px !important;">
      <div class="right">
        <div class="size-box">
          <label class="item-title">素材尺寸 </label>
          <el-select class="query-item" @change="submitSearch" v-model="param.widthHeights" multiple
                     placeholder="请选择尺寸">
            <el-option
                v-for="item in sizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="tag-box">
          <label class="item-title">素材标签</label>
          <el-select class="query-item" @change="submitSearch" v-model="param.tagNames" multiple placeholder="请选择标签">
            <el-option v-for="item in materialTags"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="time-box">
          <label class="item-title">更新时间 </label>
          <el-select class="query-item" @change="submitSearch" v-model="param.searchTime" placeholder="全部时间">
            <el-option
                v-for="item in searchOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="group-box">
          <label>联动组</label>
          <el-select v-model="param.tplGroupIds" @change="onGroupChange" class="query-item" multiple clearable>
            <el-option v-for="(item, index) in templateGroupsAll" :key="index" :value="item.id"
                       :label="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div class="c-search-box absolute">
        <el-input v-model="param.name" @change="submitSearch" placeholder="按素材名称搜索"></el-input>
        <el-button class="c-search-btn" type="primary" @click="submitSearch" circle
                   icon="iconfont icon-search"></el-button>
      </div>
    </el-header>
    <div class="down-opration container-header">
      <div class="left">
        <el-checkbox v-model="checkAll" @change="toggleCheckAll" :disabled="items.length === 0">全选</el-checkbox>
        <el-dropdown trigger="click" @command="uploadImg" placement="bottom" style="margin-right:10px;">
          <el-button :loading="elementLoading" type="primary" round>
            上传<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="local">本地上传</el-dropdown-item>
            <el-dropdown-item command="ps">智能抠图并上传</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <upload class="upload c-hide"
                :projectId="projectId"
                :action="MATERIAL_UPLOAD"
                @success="uploadSuccess"
                @error="uploadError"
                :type="materialType[type]"
                @beforeUplad="elementLoading = true">
          <template slot="target">
            <el-button type="primary" round :loading="elementLoading" @click="onClickUpload" ref="localUploadDom">上传
            </el-button>
          </template>
        </upload>
        <el-button round style="margin-right: 10px;" :disabled="!selectList.length" @click="onAddTplGroup">添加分组
        </el-button>
        <el-button round style="margin-right:10px;" @click="addTag" :disabled="!selectList.length">添加标签</el-button>
        <el-popover popper-class="c-delete-propper" v-model="visible1">
          <p><i class="el-icon-warning"></i>你确认要删除这些素材吗？</p>
          <div style="text-align: right; margin: 0">
            <el-button @click="visible1=false">取消</el-button>
            <el-button type="primary" @click="visible1=false; delMoreMaterial($event)">确定</el-button>
          </div>
          <el-button :loading="loadingDelete" slot="reference" class="header-del" :disabled="!selectList.length" round>
            删除
          </el-button>
        </el-popover>
      </div>
    </div>
    <el-main :style="getWidth()" class="items-container" v-loading.lock="loading"
             element-loading-background="rgba(256,256,256, 0.65)" element-loading-text="拼命加载中, 请稍候"
             element-loading-spinner="el-icon-loading">
      <div :style="getListStyle()">
        <div class="m-item" :span="4" v-for="item in items" :key="item.id">
          <div class="m-box">
            <div class="item-box">
              <img :src="item.url + '?imageView&thumbnail=200x0'">
              <div class="mask" :class="item.check ? 'active' : ''" @click="toggleCheck(item)">
                <i class="checkbox iconfont"
                   :class="item.check ? 'active icon-check-checked' : 'icon-check-hover'"></i>
              </div>
            </div>
            <div style="padding: 15px 10px">
              <el-popover
                  popper-class="no-arrow material"
                  placement="right-start"
                  width="90"
                  trigger="hover"
                  visible-arrow=false>
                <ul>
                  <li @click="openDialogForGroup(item)">修改分组</li>
                  <li @click="onDelGroup(item)" v-if="hasGroup(item)">清空分组</li>
                  <li @click="addTag($event, item)">修改标签</li>
                  <li @click="openDialogForm(item)">修改名称</li>
                  <el-popover :popper-class="'c-delete-propper ' + (type === 'bg'?'delete-propper-bg':'')"
                              placement="bottom-end" v-model="item.visible1">
                    <p><i class="el-icon-warning"></i>你确认要删除该素材吗？</p>
                    <div style="text-align: right; margin: 0">
                      <el-button @click="item.visible1=false">取消</el-button>
                      <el-button type="primary" @click="item.visible1=false; delOneMaterial($event, item)">确定
                      </el-button>
                    </div>
                    <li slot="reference">删除</li>
                  </el-popover>
                </ul>
                <div class="item-menu" slot="reference">
                  <i class="el-icon-more"></i>
                </div>
              </el-popover>
              <div class="item-name c-ellipsis"
                   :title="`${item.name}${type === 'bg' ? '——' + (item.groupName ? ('联动组：' + item.groupName) : '未分组') : ''}`">
                <span v-html="item.nameShow"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-main>
    <noResult v-show="!items.length && !loading">
      <div>
        <div v-if="searchContent || param.updateTimeStart">
          <div class="title">没有找到对应的素材</div>
          <el-button type="primary" @click="getAllData" round>查看全部</el-button>
        </div>
        <div v-else>
          <div class="title">您还没有素材</div>
          <div>请点击<a @click="uploadImg('local')">本地上传</a>/<a @click="uploadImg('ps')">智能抠图并上传</a></div>
        </div>
      </div>
    </noResult>
    <el-footer class="m-footer" v-show="items.length">
      <el-pagination
          v-if="items.length"
          @size-change="sizeChange"
          @current-change="currentChange"
          background
          layout="total, sizes, ->, prev, pager, next, jumper"
          :total="totalItems"
          :current-page="param.pageNum"
          :page-sizes="[30, 60, 90, 120]"
          :page-size="param.pageSize">
      </el-pagination>
    </el-footer>
    <el-dialog v-if="addTagVisible" :visible.sync="addTagVisible"
               custom-class="add-tag-dialog"
               width="640px"
               class="global-dialog"
               title="添加素材标签">
      <div>支持自定义多个标签，点击Enter键完成单个标签输入</div>
      <self-select
          v-model="addTags.tags"
          ref="tagSelect">
        <self-option value="" key="-1" @onClick="newTag">
          <div slot="header">新建标签</div>
        </self-option>
        <self-option
            v-for="item in materialTags"
            :key="item.value"
            :label="item.label"
            :value="item.value">
        </self-option>
      </self-select>
      <span slot="footer">
                <el-button class="c-button" @click="addTagVisible = false;">取消</el-button>
                <el-button class="c-button" type="primary" @click="saveAddTag" :loading="addTagLoading">确认</el-button>
            </span>
    </el-dialog>

    <input type="file" id="group-uploads" webkitdirectory directory style="display:none" accept="image/png,image/jpeg"
           @change="chooseFolder($event)">
    <input type="file" id="bg-uploads" multiple accept="image/png,image/jpeg" style="display:none"
           @change="chooseBGS($event)">
    <group-form-dialog :data-list="templateGroupsAll"
        v-model="materialGroupVisible"
        :confirmLoading="confirmLoading"
        :isNew="!currentMaterial.id"
        @onConfirm="onConfirmForMaterialGroup"
        :groupIds="currentMaterial.tplGroupIds"
        :project-id="projectId"></group-form-dialog>
    <material-form v-model="formVisible" :data="updateItem" @onSaveAfter="onSaveFormData"></material-form>
  </el-container>
</template>

<script>
    import materialService from '../../request/service/material-service'
    import templateService from '../../request/service/template-service'
    import uploadService from '../../request/service/fileupload-service'
    import upload from '../components/upload/upload-index'
    import {material_type, theme_type_bg, time_selections} from '@/const.js'
    import util from '@/util.js';
    import routerMixin from '@/mixins/router-mixin.js';
    import noResult from '../components/noResult';
    import {MATERIAL_UPLOAD} from '../../request/api/fileupload-api';
    import groupFormDialog from './components/group-form-dialog'
    import materialForm from './material-form'
    const REG = /^#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})$/;
    const empty_material = {id: null, tplGroupIds: null, name: ''};
    export default {
        props: {
            type: String,
            publicProject: { // 路由配置中设置的props属性值， 区分是否是公共素材
                type: Boolean, default: false
            },
        },
        components: {
            upload,
            noResult,
            groupFormDialog,
            materialForm
        },
        mixins: [routerMixin],
        data() {
            let validateColor = (rule, value, callback) => {
                if (!REG.test(value)) {
                    return callback(new Error('颜色值不合法'));
                } else {
                    callback();
                }
            };
            return {
                materialType: material_type,
                MATERIAL_UPLOAD: MATERIAL_UPLOAD,
                items: [],
                selectList: [],
                sizeOptions: [],
                addToGroup: {
                    materialIds: [],
                    groupId: '',
                },
                addTags: {
                    tags: [],
                    pickedTemplate: ''
                },
                searchOptions: time_selections,
                colorPicker: '',
                index: 0,
                checkAll: false,
                elementLoading: false,
                searchContent: '',
                totalItems: 0,
                param: {
                    pageNum: 1,
                    pageSize: 30,
                    name: '',
                    updateTimeStart: '',
                    searchTime: '',
                    widthHeights: [],
                    tplGroupIds: null,
                    tagNames: [],
                },
                loading: true,
                loadingDelete: false,
                loadingUpload: false,
                visible1: false,
                // uploadSetGroupVisibel: false,
                setGroupVisibel: false,
                addGroupVisibel: false,
                addTagVisible: false,
                groups: [],
                textColor: '',
                rules: {
                    groupName: [
                        {required: true, message: '请输入组名', trigger: 'blur'},
                    ],
                    color: [
                        {validator: validateColor, trigger: 'change'}
                    ],
                },
                addTagLoading: false,
                materialGroupVisible: false,
                confirmLoading: false,
                currentMaterial: Object.assign({}, empty_material),
                updateItem: Object.assign({}, empty_material),
                templateGroupsAll: [],
                materialTags: [],
                formVisible: false
            }
        },
        computed: {
            projectId() {
                if (this.publicProject) {
                    return this.$store.state.app.loginUser.publicProject.id;
                } else {
                    return this.$store.state.app.projectId;
                }
            },
        },
        created() {
            let query = this.$route.query;
            this.param.pageNum = +(query.pageNum || 1);
            this.param.pageSize = +(query.pageSize || 30);
            this.param.name = query.name;
            this.param.searchTime = query.searchTime;
            this.param.tplGroupId = query.groupId;
            this.init();
        },
        watch: {
            'param.groupId'(val) {
                this.addToGroup.groupId = val;
            },
            type(newValue, oldValue) {
                if (oldValue) {
                    this.param = {
                        pageNum: 1,
                        pageSize: 30,
                        name: '',
                        updateTimeStart: '',
                        searchTime: '',
                        widthHeights: [],
                        groupId: '',
                        tagNames: [],
                    }
                }
                this.selectList = [];
                this.getData();
                this.getMaterialsSize();
                this.getGroupList();
                this.getMaterialsTag();
            },
            projectId(newValue, oldValue) {
                if (oldValue) {
                    this.param = {
                        pageNum: 1,
                        pageSize: 30,
                        name: '',
                        updateTimeStart: '',
                        searchTime: '',
                        widthHeights: [],
                        groupId: '',
                        tagNames: [],
                    }
                    this.$router.push({path: this.$route.path});
                } else {
                    this.$router.push({path: this.$route.path, query: this.param});
                }
                this.getData();
                this.getMaterialsSize();
                this.getGroupList();
            },
            selectList: function (val) {
                if (val.length >= this.items.length) {
                    this.checkAll = true;
                } else {
                    this.checkAll = false;
                }
            },
            items: function (val) {
                if (val.length >= this.selectList.length) {
                    this.checkAll = false;
                } else {
                    this.checkAll = true;
                }
            }
        },
        methods: {
            init() {
                this.getData();
                this.getMaterialsSize();
                this.getGroupList();
                this.getQueryConditions();
            },
            getQueryConditions() {
                templateService.getTemplateGroupByProjectId(this.projectId, '').then((data) => {
                    let array = [];
                    data.forEach((v) => {
                        if (!v.isDefault) {
                            array.push({
                                value: v.name,
                                id: v.id
                            });
                        }
                    });
                    this.templateGroupsAll = array;
                });
                materialService.getMaterialTag(this.projectId).then((data) => {
                    this.materialTags = data;
                });
            },
            getMaterialsSize() {
                let params = {
                    type: this.materialType[this.type],
                    projectId: this.projectId
                }
                materialService.getMaterialsSize(params).then((result) => {
                    this.sizeOptions = result.map((size) => {
                        return {label: size, value: size}
                    });
                });
            },
            getMaterialsTag() {
                this.$store.dispatch('app/queryMaterialTags', this.projectId)
            },
            getData() {
                switch (this.param.searchTime) {
                    case '1':
                        this.param.updateTimeStart = (moment(new Date()).subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'));
                        break;
                    case '2':
                        this.param.updateTimeStart = (moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD HH:mm:ss'));
                        break;
                    case '3':
                        this.param.updateTimeStart = (moment(new Date()).subtract(3, 'months').format('YYYY-MM-DD HH:mm:ss'));
                        break;
                    case '4':
                        this.param.updateTimeStart = (moment(new Date()).subtract(6, 'months').format('YYYY-MM-DD HH:mm:ss'));
                        break;
                    case '5':
                        this.param.updateTimeStart = (moment(new Date()).subtract(1, 'years').format('YYYY-MM-DD HH:mm:ss'));
                        break;
                    default:
                        this.param.updateTimeStart = '';
                        break;
                }
                materialService.getMaterialList(Object.assign({}, this.param, {
                    type: this.materialType[this.type],
                    projectId: this.projectId
                })).then((data) => {
                    this.totalItems = data.total;
                    this.loading = false;
                    let newSelectList = [];
                    data.list.forEach((item) => {
                        this.formatName(item);
                        if (this.selectList.indexOf(item.id) !== -1) {
                            item.check = true;
                            newSelectList.push(item.id);
                        } else {
                            item.check = false;
                        }
                        item.visible1 = false;
                        item.isNameEdit = false;
                    });
                    this.selectList = newSelectList;
                    this.searchContent = this.param.name;
                    this.loading = false;
                    this.items = data.list;
                });
            },
            formatName(item){
                let findText = item.name.split(this.param.name);
                item.nameShow = findText.join('<span style="color:red">' + this.param.name + '</span>');
            },
            getWidth() {
                return util.getWidth();
            },
            getListStyle() {
                let w = util.getWidthNum(), tplW = 220;
                let margin = w - Math.floor(w / tplW) * tplW;
                return `margin-left: ${margin / 2}px;`
            },
            getGroupList() {
                materialService.getGroupList(this.projectId).then((data) => {
                    data.forEach((item) => {
                        item.label = item.name;
                        item.value = item.id;
                        if (item.id == this.param.groupId) {
                            this.textColor = item.textColor;
                        }
                    });
                    this.groups = data;
                }).catch((err) => {
                    console.log(err);
                });
            },
            uploadSuccess(data) {
                if (data.failCount > 0) {
                    materialService.downloadUselessMaterial(data.invalidStorageIds).then((result1) => {
                        let url = window.URL.createObjectURL(result1.data);
                        let zipName = this.getDownloadFileName(result1.headers);
                        this.$confirm(`
                            <div class="title">
                                <i class="el-icon-warning" style="color: #F5A624;"></i>存在${data.failCount}个不可用素材
                            </div>
                            <div class="content">
                                <div>素材尺寸比例与现有素材不同，请保持比例为1:1</div>
                                <a download="${zipName}" href="${url}">下载不可用素材</a>
                            </div>`, {
                            cancelButtonText: '知道了',
                            showConfirmButton: false,
                            showClose: false,
                            dangerouslyUseHTMLString: true,
                            customClass: 'material-message',
                            cancelButtonClass: 'button',
                            type: 'text'
                        }).then(() => {
                        }).catch(() => {
                        });
                    });
                }else{
                    this.$message.success({message: '上传成功', duration: 1000, showClose: true})
                }
                this.getData();
                this.getMaterialsSize();
                this.elementLoading = false;
            },
            uploadError(err) {
                this.$message({
                    type: 'error',
                    message: err.message,
                });
                this.bgLoading = false;
                this.elementLoading = false;
            },
            sizeChange(size) {
                this.param.pageSize = size;
                this.$router.push({path: this.$route.path, query: this.param});
                this.getData();
            },
            currentChange(num) {
                this.param.pageNum = num;
                this.$router.push({path: this.$route.path, query: this.param});
                this.getData();
            },
            toggleCheckAll(val) {
                this.selectList = [];
                this.items.forEach((item) => {
                    item.check = val;
                    if (val) {
                        this.selectList.push(item.id);
                    }
                });
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.selectAll.key);
            },
            toggleCheck(item) {
                item.check = !item.check;
                if (item.check) {
                    this.selectList.push(item.id);
                } else {
                    this.selectList.splice(this.selectList.indexOf(item.id), 1)
                }
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.check.key);
            },
            deleteMaterial(e, item) {
                let items;
                if (item && item.id) {
                    items = [item.id];
                } else {
                    items = this.selectList;
                }
                materialService.deleteMaterials(items).then(() => {
                    this.getData();
                    this.getMaterialsSize();
                    this.$message({
                        type: 'success',
                        message: '删除成功',
                        duration: 1000,
                        showClose: true,
                    });
                    if (item && this.selectList.indexOf(item.id) > -1) {
                        this.selectList.splice(this.selectList.indexOf(item.id), 1);
                    }
                }).catch(() => {
                    console.log('删除失败');
                }).finally(() => {
                    this.loadingDelete = false;
                });
            },
            delOneMaterial(e, item) {
                this.deleteMaterial(e, item);
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.del.key);
            },
            delMoreMaterial(e, item) {
                this.loadingDelete = true;
                this.deleteMaterial(e, item);
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.batchDel.key);
            },
            submitSearch(ev, flag) {
                this.param.pageNum = 1;
                // 切换分组需要联动主题色
                if (flag === 'changeGroup') {
                    let color = this.groups.find((item) => {
                        return item.value == ev;
                    });
                    if (color) {
                        this.textColor = color.textColor;
                    } else {
                        this.textColor = '';
                    }
                }
                this.getData();
                let query = Object.assign({}, {...this.$route.query}, this.param);
                this.$router.push({path: this.$route.path, query: query});
                let pageName = this.getPageName();
                if (this.param.searchTime) {
                    this.saveUserAction(pageName, this.ActionType.material.timeSearch.key);
                }
                if (this.param.name) {
                    this.saveUserAction(pageName, this.ActionType.material.nameSearch.key);
                }
                if (this.param.tagNames && this.param.tagNames.length > 0) {
                    this.saveUserAction(pageName, this.ActionType.material.tagSearch.key);
                }
                if (this.param.widthHeights && this.param.widthHeights.length > 0) {
                    this.saveUserAction(pageName, this.ActionType.material.sizeSearch.key);
                }
                if (this.param.groupId) {
                    this.saveUserAction(pageName, this.ActionType.material.groupSearch.key);
                }
            },
            getAllData() {
                this.param.name = '';
                this.param.searchTime = '6';
                this.$router.push({path: this.$route.path});
                this.getData();
                this.getMaterialsSize();
            },
            getPageName() {
                return this.type === 'bg' ? this.ActionType.material.bgName.key : this.ActionType.material.imgName.key;
            },
            onClickUpload() {
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.upload.key);
            },
            uploadImg(command) {
                if (command === 'local') {
                    this.$refs.localUploadDom.$el.click();
                } else if (command === 'ps') {
                    let newpage = this.$router.resolve({
                        path: '/img/ps',
                    });
                    window.open(newpage.href, '_blank');
                }
            },
            chooseFolder(e) {
                if (!e.target.files.length) { //点击取消
                    return;
                }
                let files = e.target.files;
                let folderName = files[0].webkitRelativePath.split('/')[0];
                let themeColor = '#' + files[0].webkitRelativePath.split('/')[0].split('#')[1];
                let groupName = files[0].webkitRelativePath.split('/')[0].split('#')[0];
                let uploadGroup = [];
                let promises = [];
                let uploadItems = [];
                let reg = /.+#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})/;
                this.loadingUpload = true;
                if (!reg.test(folderName)) {
                    this.$confirm(`
                        <div class="title">
                            <i class="el-icon-error" style="color:#F2534C;"></i>文件夹命名错误
                        </div>
                        <div class="content">请命名为：联动组名#主题色颜色值，如“浅色背景#333333”</div>`, {
                        cancelButtonText: '知道了',
                        showConfirmButton: false,
                        showClose: false,
                        dangerouslyUseHTMLString: true,
                        customClass: 'material-message',
                        cancelButtonClass: 'button',
                        type: 'text'
                    }).then(() => {
                    }).finally(() => {
                        this.loadingUpload = false;
                    });
                } else {
                    let hasImg = false;
                    for (let index = 0; index < files.length; index++) {
                        if (files[index].type === 'image/png' || files[index].type === 'image/jpeg') {
                            hasImg = true;
                            uploadGroup.push(files[index]);
                        }
                    }
                    if (!hasImg) {
                        this.$confirm(`
                            <div class="title">
                                <i class="el-icon-error" style="color:#F2534C;"></i>您的分组下没有可用背景
                            </div>
                            <div class="content">
                                <ul>
                                    <li>背景仅支持PNG和JPG格式；</li>
                                    <li>同一联动组下背景尺寸不可相同；</li>
                                </ul>
                            </div>`, {
                            cancelButtonText: '知道了',
                            showConfirmButton: false,
                            showClose: false,
                            dangerouslyUseHTMLString: true,
                            customClass: 'material-message',
                            cancelButtonClass: 'button',
                            type: 'text'
                        }).then(() => {
                        }).finally(() => {
                            this.loadingUpload = false;
                        });
                    } else {
                        for (let index = 0; index < uploadGroup.length; index++) {
                            let formData = new FormData();
                            formData.append('file', uploadGroup[index], uploadGroup[index].name);
                            promises[index] = uploadService.uploadFile(formData).then((result) => {
                                uploadItems.push({
                                    name: result.displayName.split('.')[0],
                                    widthHeight: result.properties || '0x0',
                                    url: result.url,
                                    storageId: result.id,
                                });
                            });
                        }
                        Promise.all(promises).then(() => {
                            console.log(uploadItems);
                            materialService.batchSaveBGMaterial({
                                projectId: this.projectId,
                                themeColor,
                                type: 'BG',
                                group: groupName,
                                items: uploadItems
                            }).then((result) => {
                                this.param.groupId = result.groupId;
                                this.$router.push({path: this.$route.path, query: this.param});
                                this.getData();
                                this.getGroupList();
                                if (result.failCount == 0) {
                                    this.$confirm(`
                                        <div class="title">
                                            <i class="el-icon-success" style="color:#1BD18E;"></i>成功上传${result.successCount}个背景
                                        </div>
                                        <div class="content">
                                            联动分组为“${result.group}”，主题字颜色${result.themeColor}
                                        </div>`, {
                                        confirmButtonText: '确定',
                                        showCancelButton: false,
                                        showClose: false,
                                        dangerouslyUseHTMLString: true,
                                        customClass: 'material-message',
                                        confirmButtonClass: 'button',
                                        type: 'text'
                                    }).then(() => {
                                    });
                                } else {
                                    materialService.downloadUselessMaterial(result.invalidStorageIds).then((result1) => {
                                        console.log(result1.data);
                                        let url = window.URL.createObjectURL(result1.data);
                                        let zipName = this.getDownloadFileName(result1.headers);
                                        this.$confirm(`
                                            <div class="title">
                                                <i class="el-icon-success" style="color:#1BD18E;"></i>成功上传${result.successCount}个背景
                                            </div>
                                            <div class="content">
                                                <div>联动分组为“${result.group}”，主题字颜色${result.themeColor}</div>
                                                <span class="error-info">${result.failCount}个背景上传失败</span>
                                                <ul style="list-style: disc;padding-left:20px;">
                                                    <li>背景仅支持PNG格式；</li>
                                                    <li>同一联动组下背景尺寸不可相同；</li>
                                                </ul>
                                                <a download="${zipName}" href="${url}">下载查看</a>
                                            </div>`, {
                                            confirmButtonText: '确定',
                                            showCancelButton: false,
                                            dangerouslyUseHTMLString: true,
                                            customClass: 'material-message',
                                            confirmButtonClass: 'button',
                                            type: 'text'
                                        }).then(() => {
                                        });
                                    });
                                }
                            }).catch((err) => {
                                console.log(err);
                                this.$confirm(`<div style="font-size:18px;margin-bottom:15px;"><i class="el-icon-warning" style="color:red;margin-right:5px;"></i>分组名称不可重复</div>
                                        `, {
                                    confirmButtonText: '知道了',
                                    showCancelButton: false,
                                    dangerouslyUseHTMLString: true,
                                    type: 'text'
                                }).then(() => {
                                });
                            });
                        }).catch((err) => {
                            console.log(err);
                        }).finally(() => {
                            this.loadingUpload = false;
                        });
                    }
                }
                e.target.value = ''; //避免选择相同的文件不触发onchange
            },
            onProgress(val) {
                console.info(val)
            },
            chooseBGS(e) {
                if (!e.target.files.length) {
                    return;
                }
                let promises = [];
                let uploadItems = [];
                let files = e.target.files;
                this.loadingUpload = true;
                for (let index = 0; index < files.length; index++) {
                    let formData = new FormData();
                    formData.append('file', files[index], files[index].name);
                    promises[index] = uploadService.uploadFile(formData).then((result) => {
                        uploadItems.push({
                            name: result.displayName.split('.')[0],
                            widthHeight: result.properties || '0x0',
                            url: result.url,
                            storageId: result.id,
                        });
                    }).catch(() => {
                        console.log(files[index].name + '上传失败');
                    });
                }
                Promise.all(promises).then(() => {
                    materialService.batchSaveBGMaterial({
                        projectId: this.projectId,
                        type: 'BG',
                        items: uploadItems
                    }).then((result) => {
                        if (result.failCount == 0) {
                            this.setGroupVisibel = true;
                            this.addToGroup.materialIds = result.successMaterialIds;
                        } else {
                            this.$message.error(result.failCount + '个背景上传失败');
                        }
                        console.log(result);
                        this.getData();
                    });
                }).finally(() => {
                    this.loadingUpload = false;
                });
                e.target.value = '';
            },
            getDownloadFileName(headers) {
                let name = headers['content-disposition'].split(';')[1].split('=')[1].split('.');
                return decodeURI(name[0]) + '.' + name[1];
            },
            setOneGroup(item) {
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.group.key);
                this.setGroup(item);
            },
            setBatchGroup(item) {
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.batchGroup.key);
                this.setGroup(item);
            },
            setGroup(item) {
                this.setGroupVisibel = true;
                if (item.id) {
                    this.addToGroup.groupId = item.groupId;
                    this.addToGroup.materialIds = [item.id];
                } else {
                    this.addToGroup.materialIds = this.selectList;
                }
            },
            colorInputChange() {
                if (REG.test(this.$refs.themeColor.value)) {
                    this.colorPicker = this.$refs.themeColor.value;
                }
            },
            colorPickerChange(ev) {
                this.addThemeColor.color = ev;
            },
            saveAddTag() {
                this.addTagLoading = true;
                let params = {
                    tagNames: this.addTags.tags,
                };
                if (this.addTags.pickedTemplate) {
                    params.materialId = this.addTags.pickedTemplate;
                    materialService.setMaterialTag(params, this.projectId).then(() => {
                        this.addTagVisible = false;
                        this.getQueryConditions();
                        this.getData();
                    }).finally(() => {
                        this.addTagLoading = false;
                    });
                } else {
                    params.materialIds = this.selectList;
                    materialService.batchSetMaterialTag(params, this.projectId).then(() => {
                        this.addTagVisible = false;
                        this.getQueryConditions();
                        this.getData();
                        this.selectList = [];
                    }).finally(() => {
                        this.addTagLoading = false;
                    });
                }
            },
            addTag(e, item) {
                this.addTagVisible = true;
                if (item) {
                    this.addTags.pickedTemplate = item.id;
                    this.addTags.tags = item.tags ? item.tags.map((tag) => tag.name) : [];
                } else {
                    this.addTags.pickedTemplate = '';
                    this.addTags.tags = [];
                }
                let pageName = this.getPageName();
                this.saveUserAction(pageName, this.ActionType.material.addTag.key);
            },
            newTag() {
                this.$refs.tagSelect.togglePopover(false);
            },
            onAddTplGroup() {
                this.materialGroupVisible = true;
                this.currentMaterial = Object.assign({}, empty_material);
            },
            openDialogForGroup(item) {
                this.materialGroupVisible = true;
                this.currentMaterial = item;
                let groupIds = item.tplGroups.map((obj) => {
                    return obj.id;
                });
                this.currentMaterial.tplGroupIds = groupIds;
            },
            onConfirmForMaterialGroup(ids) {
                if (this.currentMaterial.id) {//修改分组
                    this.confirmLoading = true;
                    materialService.updateMaterialGroup(this.projectId, this.currentMaterial.id, ids).then(() => {
                        this.$message.success('添加成功');
                        this.materialGroupVisible = false;
                        this.currentMaterial = Object.assign({}, empty_material);
                        this.getData();
                    }).finally(() => {
                        {
                            this.confirmLoading = false;
                        }
                    });
                } else { //添加分组
                    if (this.selectList.length > 0 && ids) {
                        this.confirmLoading = true;
                        materialService.addMaterialGroup(this.projectId, this.selectList, ids).then(() => {
                            this.$message.success('添加成功');
                            this.materialGroupVisible = false;
                            this.getData();
                        }).finally(() => {
                            {
                                this.confirmLoading = false;
                            }
                        });
                    }
                }
            },
            onGroupChange() {
                if (this.timeVal) {
                    window.clearTimeout(this.timeVal)
                }
                this.timeVal = setTimeout(() => {
                    this.getData();
                }, 800);
            },
            hasGroup(item) {
                return item.tplGroups && item.tplGroups.length > 0;
            },
            onDelGroup ({projectId, id}) {
                this.$confirm('确认清空所有分组?', {}).then(() => {
                    materialService.removeMaterialGroup(projectId, id).then(() => {
                        this.$message.success('操作成功');
                        this.getData()
                    })
                }).catch(() => {
                });
            },
            openDialogForm (item) {
                this.formVisible = true;
                this.updateItem = item;
            },
            onSaveFormData(item){
                this.formVisible = false;
                this.updateItem.name = item.name;
                this.formatName(this.updateItem);
                this.updateItem = Object.assign({}, empty_material);
            }
        }
    }
</script>
<style lang="scss">
  @import './material.scss';
</style>
